import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=87972df6&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=87972df6&prod&lang=scss&scoped=true"
import style1 from "./FileUploader.vue?vue&type=style&index=1&id=87972df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87972df6",
  null
  
)

export default component.exports